import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Link } from '@material-ui/core';

import feasr from '../assets/images/feasr.jpg';

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
  },
  feasr: {
    width: '100%',
  },
  textContainer: {
    padding: theme.spacing(3, 2),
  },
  legalLinks: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  legalLink: {
    color: '#fff',
    fontSize: '14px',
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
}));

const Footer: React.FC = () => {
  const classes = useStyles();

  return (
    <>
      <Container disableGutters>
        <Box>
          <img src={feasr} alt="" className={classes.feasr} />
        </Box>
      </Container>
      <footer className={classes.footer}>
        <Container className={classes.textContainer}>
          <Typography variant="body1">
            Società Agricola L'orto Dei F.lli Compagnoni S.s.
            <br />
            Via Baccanina, 2 41037 Mirandola (MO)
            <br />
            P.Iva 03824940369
          </Typography>

          <Box className={classes.legalLinks}>
            <Link component={RouterLink} to="/privacy-policy" className={classes.legalLink}>
              Privacy Policy
            </Link>
            <Link component={RouterLink} to="/cookie-policy" className={classes.legalLink}>
              Cookie Policy
            </Link>
            <Link component={RouterLink} to="/termini-condizioni" className={classes.legalLink}>
              Termini e Condizioni
            </Link>
          </Box>

          <Typography variant="body2">{`Copyright © L'orto dei F.lli Compagnoni ${new Date().getFullYear()}.`}</Typography>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
